import _ from 'lodash';
import React, { createContext, useContext, useReducer, useState } from 'react';
import { Segment } from 'semantic-ui-react';
import { creatingHelpers } from '../../../global/common/creating';
import { appFormTypes } from '../../../global/enums/appFormTypes';
import { gEnums } from '../../../global/enums/globalEnums';
import GolfParentProvider, { GolfParentContext } from '../cnr/contexts/GolfParentContext';
import { golfCreateHandlers, golfCreateInitialState, golfCreateReducer } from '../cnr/reducers/GolfCreateReducer';
import { createMatchScorecardsWithResults } from '../golfCalcs/createMatchScorecards';
import FullPageWrapper from '../../../global/wrappers/FullPageWrapper';
import Wrapper, { wrapperTypes } from '../../../global/wrappers/Wrapper';
import UiSaveButtons from '../../../global/components/buttons/UiSaveButtons';
import { GolfRoundContext } from '../cnr/contexts/GolfRoundContext';
import { _roundWizardTypes } from '../cnr/reducers/GolfRoundReducer';
import GolfCourses from '../elements/GolfCourses';
import { DateTimePicker } from 'global/components/forms/elements/DateTimePicker';
import { formatDate } from 'date-fns';
import { _timeZones, formatItem, formatTypes } from 'global/common/dateFormatting';
import GolfLineup from '../elements/GolfLineup';
import GolfLineupSelect from '../elements/GolfLineupSelect';
import ItemMenuSquares, { _imsTypes } from 'global/wrappers/ItemMenuSquares';
import CreateGolfCourse from './CreateGolfCourse';
import { useGolf } from '../useHelpers/useGolf';

const CreateGolfRoundMatches = React.lazy(() => import('./GolfRoundOptions'));
const CreateGolfTournament = React.lazy(() => import('./CreateGolfTournament'));
const ImportGolfTournament = React.lazy(() => import('./ImportGolfTournament'));

export const CreateGolfContext = createContext();

const CreateGolf = (props) => {

  const _asat = gEnums.availableSubActionTypes

  const { roundWizardProps, fromDashboard, subActionType, viewItem, actionDataItem, opts } = props
  const { id: golfRoundKey } = actionDataItem ?? {}
  const { golfCourseKey } = opts ?? {}

  const { roundWizardType } = roundWizardProps ?? {}

  const _subActionType = roundWizardType ? roundWizardType : subActionType

  // golfParentContext
  const golfParentContext = useContext(GolfParentContext)
  const { golfParent_contexts, golfParent_cls } = golfParentContext ?? {}
  const { states, handlers } = golfParent_contexts ?? {}
  const { golfTournament_state, golfEvent_state, item_state, paps_state } = states ?? {}
  const { item_handlers, golfTournament_handlers, golfEvent_handlers } = handlers ?? {}
  const { golfMatches, holes, details, golfTournament } = golfTournament_state ?? {}
  const { teams } = details ?? {}

  const golfRoundContext = useContext(GolfRoundContext)
  const { golfRound_handlers, golfRound_state } = golfRoundContext ? golfRoundContext : {}
  const { showCourseRoundType } = golfRound_state ?? {}

  const { handleAmmend_roundsDateAndTime, handleUpdate_round } = useGolf()

  // papsContext  
  const { pathViews } = paps_state ?? {}

  const { viewListData } = item_state ?? {}

  const init_state = { golfParent_cls, pathViews, subActionType: _subActionType, selectedAthletes: [], golfEvent_state, golfTournament_state }
  const [golfCreate_state, createGolf_dispatch] = useReducer(golfCreateReducer, init_state, golfCreateInitialState)
  const golfCreate_handlers = golfCreateHandlers(createGolf_dispatch, golfCreate_state)
  const { tournamentDetails } = golfCreate_state ? golfCreate_state : {}

  const [previewResult, setPreviewResult] = useState()
  const { previewData } = previewResult ? previewResult : {}

  const handleArchive = () => golfTournament_handlers.handleArchive_tournament()

  /** Handles the click of the preview button */
  const handleActionPreview = () => {

    let wins = {}

    switch (_subActionType) {

      case _asat.archiveGolfTournament:
        // golfCreate_handlers.handleCreate_golfTournament(true)
        break;

      case _asat.editGolfTournament:
      case _asat.createGolfTournament:
        // golfCreate_handlers.handleCreate_golfTournament(true)
        break;

      case _asat.createRoundMatches:
        golfCreate_handlers.handleCreate_golfRoundMatchesPreview(golfRoundKey)
        break;

      case _asat.createTempScorecards:
        const { tournamentRounds } = pathViews ?? {}
        let matchPreviews = { ...golfMatches }
        const roundMatchPreviews = tournamentRounds ? _.filter(matchPreviews, { 'round': tournamentRounds }) : {}
        if (roundMatchPreviews) {
          roundMatchPreviews.forEach(m => {
            const matchStatus = createMatchScorecardsWithResults(wins, m, holes, 1, teams)
            m.holeWinners = matchStatus.holeWinners
            m.holeScores = matchStatus.holeScores
          })
          matchPreviews = creatingHelpers.createObject(roundMatchPreviews, 'id')
        }
        setPreviewResult({ previewSuccess: true, previewData: matchPreviews })
        break;

      case _asat.createTempScorecard:
        const match = { ...actionDataItem }
        const matchStatus = createMatchScorecardsWithResults(wins, match, holes, 1, teams)
        match.holeWinners = matchStatus.holeWinners
        match.holeScores = matchStatus.holeScores
        setPreviewResult({ previewSuccess: true, previewData: match })
        break;

      case _roundWizardTypes.editDate:


      default:
      // nothing
    }
  }

  const content_archive = () => <Wrapper
    content={'Archive Tournament?'}
    footer={<UiSaveButtons save={{ caption: 'Save', oc: handleArchive }} />}
    wrapperType={wrapperTypes.padded}
  ></Wrapper >

  const content_archiveGolfers = () => <Wrapper
    content={'Archive Golfers?'}
    footer={<UiSaveButtons save={{ caption: 'Save', oc: handleArchive }} />}
    wrapperType={wrapperTypes.padded}
  ></Wrapper >

  const handleSave_roundGolfCourse = (selectedCourse) => {
    const cb = (res) => {
      const wizardProps = { roundWizardType: 'saveRoundCourses' }
      golfRound_handlers.handleShow_roundWizard(wizardProps)
      console.log('res', res)
    }
    handleUpdate_round({ roundType: showCourseRoundType, selectedCourse, callback: cb })
  }

  const handleSave_startTime = (selectedDate, selectedTime) => {
    const d = formatItem(formatTypes.shortestDate, selectedDate)
    const r = {
      key: golfRoundKey,
      startDate: d,
      startTime: selectedTime?.formatted12,
    }
    const cb = (res) => {
      const wizardProps = { roundWizardType: 'saveStartTime' }
      golfRound_handlers.handleShow_roundWizard(wizardProps)
      console.log('res', res)
    }
    handleAmmend_roundsDateAndTime({ round: r, callback: cb })
  }

  const content = () => {

    switch (_subActionType) {
      case _asat.archiveGolfTournament:
        if (fromDashboard) {
          return content_archive()
        } else {
          return <FullPageWrapper
            topperCaption={'Create Archive'}
            content={content_archive()}
            handleCancel={golfTournament_handlers?.handleShow_createArchive}
            css={{ container: 'app-dark-mode' }}
          ></FullPageWrapper>
        }

      case _asat.archiveGolfTournamentGolfers:
        if (fromDashboard) {
          return content_archiveGolfers()
        } else {
          return <FullPageWrapper
            topperCaption={'Create Golfer Archive'}
            content={content_archiveGolfers()}
            handleCancel={golfTournament_handlers?.handleShow_createArchive}
            css={{ container: 'app-dark-mode' }}
          ></FullPageWrapper>
        }

      case _asat.importGolfTournament:
        return <ImportGolfTournament appFormType={appFormTypes.createGolfTournament} />

      case _asat.createGolfTournament:
      case _asat.editGolfTournament:
        return <GolfParentProvider>
          <CreateGolfTournament subActionType={_subActionType} fromDashboard={fromDashboard} />
        </GolfParentProvider>

      case _roundWizardTypes.createRoundMatches:
      case _asat.createGolfTournamentRounds:
      case _asat.createRoundMatches:
        return <CreateGolfRoundMatches actionDataItem={actionDataItem} handleCancel={golfRound_handlers?.handleShow_roundWizard} />

      case _roundWizardTypes.showCourses:
        return <GolfCourses handleSave={handleSave_roundGolfCourse} handleCancel={golfRound_handlers.handleShow_roundWizard} golfCourseKey={golfCourseKey} />

      case _roundWizardTypes.editDate:
        return <DateTimePicker fullMode={true} handleOk={handleSave_startTime} handleCancel={golfRound_handlers.handleShow_roundWizard} />

      case _roundWizardTypes.editLineup:
        return <GolfParentProvider>
          <GolfLineupSelect roundWizardProps={roundWizardProps} handleCancel={golfRound_handlers.handleShow_roundWizard} />
        </GolfParentProvider>

      case 'golfCourses':
        return <CreateGolfCourse />

      case _asat.createGolfLineups:
        return <div>createGolfLineups</div>

      default:
        return <Segment basic>{_subActionType}</Segment>
    }
  }

  const wrapper = () => <CreateGolfContext.Provider value={{ golfEvent_state, golfEvent_handlers, golfCreate_state, golfCreate_handlers, viewItem, handleActionPreview, item_handlers }}>
    {content()}
  </CreateGolfContext.Provider>

  if (golfEvent_state && golfEvent_handlers) {
    return wrapper()
  } else {
    return <div>---</div>
  }

}

export default CreateGolf